// Thin decorative bars — sit above the footer border
const thinBarBase = {
    position: 'absolute',
    borderRadius: '999px',
    mixBlendMode: 'screen',
    height: 14,
};

export const thinBars = {
    wrapper: {
        position: 'absolute',
        top: -24,
        left: 0,
        right: 0,
        height: 44,
        overflow: 'hidden',
        opacity: 0.7,
        pointerEvents: 'none',
    },
    bar1: { ...thinBarBase, left: '-2.5%',  top: 8,  width: '28vw', background: 'linear-gradient(90deg, #FFDF10, #FF9E00)' },
    bar2: { ...thinBarBase, left: '33%',    top: 20, width: '35vw', background: 'linear-gradient(90deg, #00D7FF, #0078FF)' },
    bar3: { ...thinBarBase, right: 0,       top: 8,  width: '30vw', background: 'linear-gradient(90deg, #0078FF, #000082)' },
};

export const footer = {
    position: 'relative',
    mt: 8,
    borderTop: '1px solid rgba(255,255,255,0.05)',
};

// Three columns: brand blurb sized to its own (narrow) content, then the
// socials centred in the flexible middle column (EBL-13091 — "in the
// middle of page next to the what is ECAL blurb"), then Company/Legal
// grouped on the RHS, kept closer together than the outer grid gap via
// linkColumns' own smaller gap below.
export const grid = {
    display: 'grid',
    gridTemplateColumns: { xs: '1fr', md: 'auto 1fr auto' },
    alignItems: 'start',
    gap: 4,
    py: { xs: 5, md: 7 },
};

export const brandCol = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 2,
};

export const brandLogo = {
    height: 40,
    width: 'auto',
    flexShrink: 0,
};

export const brandTagline = {
    color: 'var(--ecal-lightgrey)',
    maxWidth: 320,
    fontSize: '0.875rem',
    lineHeight: 1.6,
};

export const socialBlock = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: { xs: 'flex-start', md: 'center' },
    justifySelf: { xs: 'start', md: 'center' },
    gap: 1.5,
};

export const socialIconRow = {
    display: 'flex',
    gap: 1.5,
};

export const socialIcon = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 36,
    height: 36,
    borderRadius: '50%',
    color: 'var(--ecal-lightgrey)',
    border: '1px solid rgba(187, 188, 188, 0.18)',
    transition: 'color 0.15s ease, border-color 0.15s ease',
    '&:hover': { color: 'var(--ecal-white)', borderColor: 'rgba(255,255,255,0.4)' },
};

export const colTitle = {
    fontSize: '0.72rem',
    textTransform: 'uppercase',
    letterSpacing: '0.18em',
    color: 'var(--ecal-lightblue)',
    mb: 1.5,
    fontWeight: 600,
};

// Company and Legal grouped with a tighter gap than the outer grid uses,
// so the two feel closer together (EBL-13091).
export const linkColumns = {
    display: 'flex',
    gap: 5,
    flexWrap: 'wrap',
};

export const linkList = {
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    listStyle: 'none',
    m: 0,
    p: 0,
};

export const link = {
    fontSize: '0.875rem',
    color: 'var(--ecal-lightgrey)',
    textDecoration: 'none',
    '&:hover': { color: 'var(--ecal-white)' },
    transition: 'color 0.15s ease',
};

export const copyrightBar = {
    borderTop: '1px solid rgba(255,255,255,0.05)',
    py: 2.5,
    display: 'flex',
    flexDirection: { xs: 'column', md: 'row' },
    alignItems: { md: 'center' },
    justifyContent: { md: 'space-between' },
    gap: 1,
};

export const copyrightText = {
    fontSize: '0.72rem',
    color: 'var(--ecal-midgrey)',
};
